import { FC } from 'react'
import { Control, useController } from 'react-hook-form'
import { Switch } from '@headlessui/react'

interface SwitchFieldProps {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?(checked: boolean): void
}

const SwitchField: FC<SwitchFieldProps> = ({ name, control, onChange }) => {
  const { field } = useController({ name, control })

  return (
    <Switch
      checked={field.value ?? false}
      onChange={(checked) => {
        field.onChange(checked)
        onChange?.(checked)
      }}
      className="group inline-flex h-6 w-11 items-center rounded-full bg-gray-200 transition data-[checked]:bg-green-50"
    >
      <span className="size-4 translate-x-1 rounded-full bg-gray-400 group-data-[checked]:bg-green-500 transition group-data-[checked]:translate-x-6" />
    </Switch>
  )
}

export { SwitchField }
